import { inject, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { ApiService } from './api.service';
import {
  StockAlertError,
  StockAlertErrorReason,
  StockAlertRequest,
  StockAlertResponse,
} from '../models/stock-alert.model';

@Injectable({ providedIn: 'root' })
export class StockAlertService {
  private readonly api = inject(ApiService);

  createAlert(req: StockAlertRequest): Observable<StockAlertResponse> {
    return this.api.post<StockAlertResponse>('/create-alert', req).pipe(
      catchError((err: unknown) => this.mapCreateError(err)),
    );
  }

  unsubscribe(token: string): Observable<{ data: string }> {
    return this.api
      .delete<{ data: string }>(`/stock-alerts/unsubscribe/${encodeURIComponent(token)}`)
      .pipe(catchError((err: unknown) => this.mapUnsubscribeError(err)));
  }

  private mapCreateError(err: unknown): Observable<never> {
    if (!(err instanceof HttpErrorResponse)) return throwError(() => err);

    const raw = (err.error?.error ?? '').toString().toLowerCase();
    let reason: StockAlertErrorReason = 'unknown';
    if (err.status === 404 || raw.includes('no existe')) reason = 'product_not_found';
    else if (raw.includes('stock disponible')) reason = 'product_has_stock';
    else if (raw.includes('disponible para precompra')) reason = 'product_is_prepurchase';
    else if (raw.includes('no está disponible')) reason = 'product_unavailable';
    else if (raw.includes('ya está suscrito')) reason = 'already_subscribed';

    return throwError(
      () => new StockAlertError(reason, err.error?.error ?? 'Error al crear alerta'),
    );
  }

  private mapUnsubscribeError(err: unknown): Observable<never> {
    if (!(err instanceof HttpErrorResponse)) return throwError(() => err);

    const reason: StockAlertErrorReason = err.status === 404 ? 'token_not_found' : 'unknown';
    return throwError(
      () => new StockAlertError(reason, err.error?.error ?? 'Error al cancelar la alerta'),
    );
  }
}
